export default {
  namespaced: true,
  bau_complement: {
    title: "Complemento BAU",
    cctv_tracking: "Monitoramento CCTV",
    property_visits: "Visitas Imoveis",
    list_title: "Complementos BAU",
    new: "Novo Complemento BAU",
    reference_number: "Número de Referência",
    select_form: "Selecione formulários",
    select_form_place_holder: "Selecione um formulário",
    selected_form: "Formulário selecionado",
    answer_form: "Iniciar formulário",
    start_form: "Iniciar formulário",
    confirm_delete: "Tem certeza de que deseja excluir este complemento BAU?",
    no_records: "Nenhum complemento BAU encontrado",
    reassign: "Reatribuir",
    confirm_cancel: "Tem certeza de que deseja cancelar este complemento BAU?",
    canceled: "Complemento BAU cancelado",
    edit_form_answers: "Editar respostas do formulario",
    related_forms: "Formularios relacionados",
    property: "Imovel",
    one_required_field_missing: "Falta 1 campo obrigatorio",
    multiple_required_fields_missing: "Faltam campos obrigatorios",
  },
};
